module.exports = __webpack_public_path__ + "img/5_116.60e76140.png";